import { I18n } from "i18n-js";
import translations from "./locales.json";

const i18n = new I18n(translations);
i18n.defaultLocale = "de";
i18n.enableFallback = true;

// Turbo Drive swaps <html lang> on each visit without reloading this module,
// so the locale is re-read on every lookup rather than once at import.
const translate = i18n.t.bind(i18n);
i18n.t = (scope, options) => {
  i18n.locale = document.documentElement.lang || "de";
  return translate(scope, options);
};
i18n.locale = document.documentElement.lang || "de";

export default i18n;
